import { ProductItemGroup } from "@domain/project/floorplan/product-item-group";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { Group } from "konva/lib/Group";

export class GroupKonva {
  static init(group: ProductItemGroup): Group {
    const groupGroup = new Group({
      id: group.id,
      name: group.name,
      draggable: false,
      groupId: group.groupId,
    });

    groupGroup.setAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY, group);

    return groupGroup;
  }
}
